(function ($) {
    window.JdaVideoInput = function ($inputElem, options) {

        /*##################################################################
		// Init
		##################################################################*/

        /*================================================
        Vars passed in on instantiation
        ================================================*/

        this.$inputElem = $inputElem;
        this.$imageWrapElem = $(this.$inputElem.data('thumb-target'));
        this.$titleWrapElem = $(this.$inputElem.data('title-target'));
        this.$descrWrapElem = $(this.$inputElem.data('descr-target'));

        // These are the defaults.
        this.settings = $.extend({
            changeTimeout: 500
        }, options);

        /*================================================
        Vars set during runtime
        ================================================*/

        /*================================================
        Other vars
        ================================================*/

        var scope = this;

        /*##################################################################
		// Methods
		##################################################################*/

        // Init
        // ----

        this.init = function () {
            if (typeof JdaVideoTools === 'undefined') throw 'JdaVideoInput depends on JdaVideoTools. Ensure that JdaVideoTools has been correctly included on the page.';
            scope.addEventListeners();

            // Check to see if the input is already populated on page load, and respond accordingly.
            scope.inputOnChange();
        };

        this.addEventListeners = function ($elem, embedType) {
            var changeTimeout;
            scope.$inputElem.on('change keyup', function () {
                clearTimeout(changeTimeout);
                changeTimeout = setTimeout(function () {
                    scope.inputOnChange();
                }, scope.settings.changeTimeout);
            });
            scope.$inputElem.on(EVENT_NAME__JDA_VIDEO_INPUT__INVALID_VIDEO_URL, function (e, data) {
                if (data.url) {
                    console.log('Invalid URL: ' + data.url);
                }
            });
        };

        this.inputOnChange = function () {
            var url = scope.$inputElem.val();
            try {
                var videoInfo = JdaVideoTools.embedHelper.discernTypeAndId(url);
            } catch (err) {
                if (err instanceof JdaVideoTools.embedHelper.EmbedHelperError) {
                    scope.$inputElem.trigger(EVENT_NAME__JDA_VIDEO_INPUT__INVALID_VIDEO_URL, {
                        url: url
                    });
                    return;
                } else {
                    throw err;
                }
            }
            JdaVideoTools.embedHelper.discernThumb(scope.$inputElem, videoInfo.type, videoInfo.id, function (thumbUrl, title, descr) {
                scope.reloadThumbAndTitle(thumbUrl, title, descr);
            }, true);
        };

        this.reloadThumbAndTitle = function (thumbUrl, title, descr) {
            if (thumbUrl) {
                this.$imageWrapElem.closest('.jda-video-input-preview-wrap').addClass('has-video');
                this.$imageWrapElem.css({ backgroundImage: 'url(' + thumbUrl + ')' });
                var $pElem = $('<p></p>');
                $pElem.text(title);
                this.$titleWrapElem.html($pElem);
                this.$descrWrapElem.val(descr).trigger('change');
            }
        }

        return this;
    }

    $.fn.jdaVideoInput = function (options) {
        var instances = [];
        this.each(function () {
            var instance = $(this).data('jdaVideoInput');
            if ((!instance) && options !== true) {
                // If options are true we are only checking to see if jdaValidate exists on the supplied element
                var instance = new JdaVideoInput($(this), options);
                $(this).data('jdaVideoInput', instance);
                instance.init();
            }
            instances.push(instance);
        });
        return instances;
    };

}(jQuery));
